<template>
  <div>
    <div class="row">
      <div class="col-12">
        <b-card header="Exclusivity Contracts" header-tag="h4" body-class="mb-3 pb-2">
              <company_contracts_datatable :row-data="contracts_exclusive" :loading-message="'Loading Contracts...'" :no-rows-message="'No Contracts Loaded'"
                                           :columns="contracts_columns" :type="'contracts_exclusivity'" :record-type="'company'"
                                           :rowClassRules="rowClassRules"></company_contracts_datatable>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-card header="General Contracts" header-tag="h4" body-class="mb-3 pb-2">
              <company_contracts_datatable :row-data="contracts_general" :loading-message="'Loading Contracts...'" :no-rows-message="'No Contracts Loaded'"
                                           :columns="contracts_columns" :type="'contracts_general'" :record-type="'company'"
                                           :rowClassRules="rowClassRules"></company_contracts_datatable>
        </b-card>
      </div>
    </div>
  </div>

</template>

<script>
import company_contracts_datatable from "datatables/company_contracts_datatable";

export default {
  name: "all_contracts",
  components: {
    company_contracts_datatable,
    'linkComponent': {
      name: 'linkComponent',
      data() {
        return {
          web_url: process.env.MIX_WEBSITE_URL
        }
      },
      template: '<a class="view_contract_link" :href="web_url + \'company/contract?link=\' + params.data.link" target="_blank" style="padding: 2px 10px">View</a>'
    }
  },
  data() {
    return {
      contracts_exclusive: null,
      contracts_general: null,

      rowClassRules: null,

      contracts_columns: [
        {headerName: 'Company Name', field: 'company_name', minWidth: 200, pinned: 'left'},
        {headerName: 'Contract', minWidth: 140, valueGetter: this.contract_types, cellStyle: {"white-space": "normal"}},
        {headerName: 'Type', minWidth: 110, valueGetter: this.contract_type, cellStyle: {"white-space": "normal"}},
        {headerName: 'Start Date', minWidth: 110, field: 'start_date'},
        {headerName: 'Length', field: 'length_months', minWidth: 90},
        {headerName: 'Expiry Date', minWidth: 120, valueGetter: this.contract_expiry},
        {headerName: 'Date Sent', minWidth: 150, valueGetter: this.date_sent_value_getter},
        {headerName: 'Sent To', field: 'sent_to_name', minWidth: 180},
        {headerName: 'Sent By', minWidth: 150, valueGetter: this.sent_by_vg},
        {headerName: 'Signed', minWidth: 100, valueGetter: this.signed_vg},
        {headerName: 'Link', field: 'link', minWidth: 85, filter: false, cellRendererFramework: 'linkComponent'},
      ]
    }
  },
  beforeMount() {
    this.rowClassRules = {
      // apply green to 2008
      'rag-green-outer': function (params) {
        return this.$moment(params.data.start_date).add(params.data.length_months, 'months').isSameOrBefore(this.$moment())
      },
    };
  },
  mounted() {
    this.get_contracts();
  },
  methods: {
    get_contracts() {
      axios.get(this.crmApiPath + 'company/contract/index').then(contracts => {
        this.contracts_exclusive = contracts.data.exclusivity
        this.contracts_general = contracts.data.general
      }).catch(error => console.log(error.response));
    },

    contract_types(params) {
      let array_types = JSON.parse(params.data.contract_types);
      let return_val = '';
      for (let i = 0; i < array_types.length; i++) {
        return_val += array_types[i];
        if (i !== array_types.length) {
          return_val += '\n';
        }
      }
      return return_val;
    },
    contract_type(params) {
      let array_types = JSON.parse(params.data.contract_types);
      let return_val = '';
      for (let i = 0; i < array_types.length; i++) {
        if (array_types[i] === 'Temporary') {
          return_val += params.data.temporary_exclusivity ? 'Exclusivity' : 'General';
        }
        if (array_types[i] === 'Permanent') {
          return_val += params.data.permanent_exclusivity ? 'Exclusivity' : 'General';
        }
        if (array_types[i] === 'Contractor') {
          return_val += params.data.contractor_exclusivity ? 'Exclusivity' : 'General';
          if (params.data.project_management_terms) {
            return_val += ' [Project Management]';
          }
        }
        if (i !== array_types.length) {
          return_val += '\n';
        }
      }
      return return_val;
    },

    sent_by_vg(params) {
      return params.data.sent_by.first_name + ' ' + params.data.sent_by.surname;
    },
    contract_start_date_value_getter(params) {
      return params.data.start_date;
    },
    contract_expiry(params) {
      let array_types = JSON.parse(params.data.contract_types);
      let check_exclusivity = false;
      for (let i = 0; i < array_types.length; i++) {
        if (params.data.temporary_exclusivity || params.data.permanent_exclusivity || params.data.contractor_exclusivity) {
          check_exclusivity = true;
          break;
        }
      }
      if (check_exclusivity) {
        return this.$options.filters.formatDateYMD(this.$moment(params.data.start_date).add(params.data.length_months, 'months'));
      }
      else {
        return '';
      }
    },
    date_sent_value_getter(params) {
      // return params.data.created_at
      return this.$options.filters.formatDateTimeYMD(params.data.created_at);
    },
    signed_vg(params) {
      return params.data.is_signed ? 'Signed' : 'Not Signed';
    }
  },
}
</script>

<style lang="scss">
//.all_contracts {
//  .contracts_height_datatable {
//    //height: calc(100vh - 130px);
//    height: 38vh;
//  }
//}

.ag-cell {
  display:        flex;
  align-items:    center;
  padding-top:    5px;
  padding-bottom: 5px;
  //justify-content: center;
}
</style>
